import React from "react";
import {TextField} from "@mui/material";
import {forms, objects} from "@atttomyx/shared-utils";

const ContactFilters = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);
        modified[field] = value;

        onSync(modified);
    }

    return <div className="user-filters">
        <div className="field">
            <TextField
                label="First Name"
                type="text"
                value={forms.sanitizeValue(data.firstName)}
                onChange={(event) => onChange("firstName", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Last Name"
                type="text"
                value={forms.sanitizeValue(data.lastName)}
                onChange={(event) => onChange("lastName", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Email"
                type="text"
                value={forms.sanitizeValue(data.email)}
                onChange={(event) => onChange("email", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Phone"
                type="text"
                value={forms.sanitizeValue(data.phone)}
                onChange={(event) => onChange("phone", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Lead Source"
                type="text"
                value={forms.sanitizeValue(data.leadSource)}
                onChange={(event) => onChange("leadSource", event.target.value)}
            />
        </div>
    </div>
}

export default ContactFilters;
